import script from "./PopupTool3.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool3.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool3.vue?vue&type=style&index=0&id=1b7bca88&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7bca88"]])

export default __exports__